module.exports = __webpack_public_path__ + "assets/img/img268.2ab057e5.png";